<script>
    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    import { logger, get_error_message } from '@wyvr/generator/universal.js';
    import Paging from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/Paging.svelte?1733898724625';
    import Error from '/srv/web/wyvr/html/releases/58819/gen/client/shop/Error.svelte?1733898724625';
    import Sort from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/Sort.svelte?1733898724625';
    import Facet from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/Facet.svelte?1733898724625';
    import { sort } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/sort_products.js?1733898724625';
    import Tags from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Tags.svelte?1733898724625';
    import { get_tags, change_tags } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/tags_helper.js?1733898724625';
    import { get_hash, update_hash } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url_hash.js?1733898724625';
    import facets from '/srv/web/wyvr/html/releases/58819/gen/client/shop/config/facets.js?1733898724625';
    import { onMount } from 'svelte';
    import { get_filtered_products, filter } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/category/filter_products.js?1733898724625';

    export let name;
    export let products;
    export let store = 'en';
    export let locale = 'en';
    export let currency = 'EUR';

    const odoscope_enabled = true;
    const items_per_page = 11;

    let sort_by = 'position';
    let asc = true;
    let filter_config = from_hash();
    let details = {};
    let show_facets = false;
    let filtered_products;
    let odoscope_products;

    onMount(() => {
        client_filter_products();
    });

    ;
    $: is_filled = array_filled(products) || array_filled(filtered_products);
    $: client_filter_products(products, filter_config, sort_by, asc);
    $: tags = get_tags(filter_config, details);
    $: trigger_events(filter_config);

    /**
     * filters and sorts the products only on the client
     */
    async function client_filter_products() {
        if (false) {
            return;
        }
        await filter_products();
    }

    /**
     * filters and sorts the products, updates the ui
     */
    async function filter_products() {
        if (!odoscope_enabled) {
            return set_default_filtered_products();
        }
        // filter the existing products to avoid empty lists
        if (!filtered_products) {
            set_default_filtered_products();
        }
        try {
            await get_filtered_products(products, filter_config, (result_products, sorted) => {
                if (result_products) {
                    odoscope_products = result_products;
                }
                // even when nothing changed sort the products based on the selected filters, required for odoscope
                const products_to_sort = result_products || odoscope_products || filtered_products;
                if (array_filled(products_to_sort)) {
                    filtered_products = sort(products_to_sort, sort_by, asc);
                    if (false) {
                        // always prefer the odoscope sorting
                        products = filtered_products;
                    }
                } else {
                    // in case of the first or when nothing gets returned and nothing is inside the filtered products already
                    set_default_filtered_products();
                }
            });
        } catch (e) {
            logger.error(get_error_message(e, import.meta.url, 'filter'));
            set_default_filtered_products();
        }
    }

    /**
     * sets the filtered products without odoscope sorting
     */
    function set_default_filtered_products() {
        filtered_products = sort(filter(products, filter_config), sort_by, asc);
    }

    function update_details(data) {
        details = data;
    }
    function array_filled(arr) {
        return Array.isArray(arr) && arr.length > 0;
    }

    let debouncer;
    function trigger_events() {
        if (false) {
            return;
        }
        clearTimeout(debouncer);
        debouncer = setTimeout(() => {
            trigger('filter.update', filtered_products);
            // update url with the filters
            update_hash(to_hash(filter_config));
        }, 1000);
    }

    function to_hash(filter_config) {
        if (!filter_config || (typeof filter_config == 'object' && Array.isArray(filter_config))) {
            return {};
        }
        const hash = {};
        // remove old hashes
        for (const key of Object.keys(get_hash())) {
            // avoid overriding following hashes
            if (['p'].indexOf(key) > -1) {
                continue;
            }
            hash[key] = undefined;
        }
        for (const [key, value] of Object.entries(filter_config)) {
            if (Array.isArray(value)) {
                hash[key] = value.join(',');
                continue;
            }
            if (typeof value === 'object') {
                hash[key] = Object.keys(value).join(',');
                continue;
            }
            hash[key] = value;
        }
        return hash;
    }
    function from_hash() {
        if (false) {
            return undefined;
        }
        let result = undefined;
        // build index of the attribute types
        const types = {};
        for (const entry of facets?.attributes || []) {
            const key = entry.as || entry.attribute;
            types[key] = entry.type;
        }

        // build the filter_options from the hash
        for (const [key, value] of Object.entries(get_hash())) {
            if (!result) {
                result = {};
            }
            if (typeof value !== 'string') {
                continue;
            }
            if (types[key] === 'slider') {
                result[key] = value.split(',').map((val) => Number.parseFloat(val));
                continue;
            }
            const items = {};
            for (const key of value.split(',')) {
                items[key] = true;
            }
            result[key] = items;
        }
        return result;
    }
</script>

{#if is_filled}
    <section>
        <h2 class="h2">{window.__('facet.filter_for')}</h2>
        <aside class:show={show_facets}>
            <Facet bind:filter={filter_config} products={filtered_products} on:details={(e) => update_details(e.detail)} />
        </aside>
        <div class="main">
            <div class="controls">
                <div class="tags">
                    <Tags {tags} on:change={(e) => (filter_config = change_tags(e.detail, filter_config))} />
                </div>
                <div class="sort">
                    <Sort bind:sort_by bind:asc />
                </div>
            </div>
            <Paging products={filtered_products} {items_per_page} {store} {name} {locale} {currency} />
            <!-- <pre>{JSON.stringify(filtered_products, null, 4)}</pre> -->
        </div>
    </section>
{:else}
    <Error text={window.__('category.no_products')} />
{/if}


<style>/* @TODO create styling */
    h2 {
        font-size: var(--h2__font-size);
        font-weight: var(--h2__font-weight);
        line-height: var(--h2__line-height);
        color: var(--h2__color);
        margin: var(--h2__margin);
        text-transform: var(--font-heading-text-transform);
    }
</style>